import { defineComponent as _defineComponent } from 'vue'
import {getShoInfo} from '@/api/miscellaneous';
import {onActivated} from 'vue';
import {onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';

export interface shopData {
    nickName: string;
    mainBusiness: string;
    position: {
        lat: number;
        lon: number;
    };
    address: string;
    mobile: string;
    profile: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'EditShop',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();
const data = ref<shopData>({
    nickName: '',
    mainBusiness: '',
    position: {
        lat: 0,
        lon: 0,
    },
    address: '',
    mobile: '',
    profile: '',
});

onMounted(() => {
    //const {id} = route.query;
    console.log('onMounted');
    getdata();
});
onActivated(() => {
    console.log('onActivated');
    getdata();
});

const getdata = () => {
    getShoInfo().then((res: any) => {
        console.log(res);
        data.value = res;
    });
};

const __returned__ = { route, router, data, getdata, getShoInfo, onActivated, onMounted, ref, useRoute, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})